import React from 'react'
import { IErrorModal } from '../../interfaces/Modal'
import { signatureIcon } from '../../assets/images/images'

const SignatureErrorModal = ({ title, onClose }: IErrorModal) => {
  return (
    <div className="modalDialog modalError">
      <div className="modalHeader">
        <span onClick={onClose} className="modalClose" />
      </div>
      <div className="modalIcon">
        <img src={signatureIcon} alt="signature icon" />
      </div>
      <div className="modalContent textCenter">
        <h2 className="modalTitle">{title}</h2>
        <strong className="dBlock mb3">
          Merci de recommencer le processus de signature.
        </strong>
        <button onClick={onClose} className="btn btnPrimary">
          Recommencer
        </button>
      </div>
    </div>
  )
}

export default SignatureErrorModal
